module.exports = __webpack_public_path__ + "img/mkds2x.4b3b0192.png";